// Wizard step: Kontrola a odeslani - per-step completeness checklist with
// jump links, submit gated on everything done (server re-checks).
import { useState } from "react";
import { type StepProps } from "./wizard-shared";
import { actionIssueLocaleKey, type ActionIssue } from "../../action-error";

export function StepReview(props: StepProps) {
  const [error, setError] = useState<ActionIssue | null>(null);
  const states = props.data.states.filter((state) => state.step !== "review" && state.step !== "overview");
  const allDone = states.every((state) => state.status === "done");
  const submitted = props.data.wizard.submitted;

  async function submit() {
    if (!props.onSubmitWizard) return;
    setError(null);
    setError(await props.onSubmitWizard());
  }

  return (
    <div className="appwiz-step">
      <header className="appwiz-step-heading">
        <h2>{props.t("appWizard.review.title")}</h2>
        <p>{props.t(submitted ? "appWizard.review.submittedCopy" : "appWizard.review.copy")}</p>
      </header>

      <ul className="appwiz-review-list">
        {states.map((state) => (
          <li key={state.step} className={`appwiz-review-item ${state.status}`}>
            <span className="appwiz-review-mark" aria-hidden="true">
              {state.status === "done" ? "✓" : state.status === "in_progress" ? "…" : ""}
            </span>
            <span className="appwiz-review-name">{props.t(`appWizard.steps.${state.step}`)}</span>
            <span className="appwiz-review-state">{props.t(`appWizard.stepState.${state.status}`)}</span>
            {state.status !== "done" && !submitted && (
              <button className="text-button" type="button" onClick={() => props.onOpenStep(state.step)}>
                {props.t("appWizard.review.finishStep")}
              </button>
            )}
          </li>
        ))}
      </ul>

      {submitted ? (
        <p className="section-action-note success-note" role="status">{props.t("appWizard.review.submittedNote")}</p>
      ) : (
        <>
          {!allDone && <p className="appwiz-inline-rule">{props.t("appWizard.review.incomplete")}</p>}
          {props.readOnly ? null : (
            <button
              className="primary-button compact-button"
              type="button"
              disabled={!allDone || props.submitting}
              onClick={() => void submit()}
            >
              {props.submitting ? props.t("appWizard.review.submitting") : props.t("appWizard.review.submit")}
            </button>
          )}
          {error && <p className="message error-message" role="alert">{props.t(actionIssueLocaleKey(error))}</p>}
        </>
      )}
    </div>
  );
}
